import { render, staticRenderFns } from "./web-nav.vue?vue&type=template&id=38a220b5&scoped=true&"
import script from "./web-nav.vue?vue&type=script&lang=js&"
export * from "./web-nav.vue?vue&type=script&lang=js&"
import style0 from "./web-nav.vue?vue&type=style&index=0&id=38a220b5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a220b5",
  null
  
)

export default component.exports